module.exports = __webpack_public_path__ + "img/tp3.ebad2557.png";